import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Landing from "@/pages/Landing";
import ProductDetail from "@/pages/ProductDetail";
import { PrivacyPolicy, Terms } from "@/pages/Policies";
import LinkInBio from "@/pages/LinkInBio";
import AdminLogin from "@/pages/AdminLogin";
import Dashboard from "@/pages/Dashboard";
import LeadMagnet from "@/pages/LeadMagnet";
import ThankYou from "@/pages/ThankYou";
import Contact from "@/pages/Contact";
import { ArticlesIndex, ArticleDetail } from "@/pages/Articles";
import AuthCallback from "@/components/AuthCallback";
import { FloatingContact } from "@/components/FloatingContact";
import { Toaster } from "@/components/ui/sonner";
import { useTracking } from "@/hooks/useTracking";

function AppRouter() {
  const location = useLocation();
  useTracking();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  const isAdminArea = location.pathname.startsWith("/dashboard") || location.pathname.startsWith("/login");
  return (
    <>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/p/:slug" element={<ProductDetail />} />
        <Route path="/kebijakan-privasi" element={<PrivacyPolicy />} />
        <Route path="/bio" element={<LinkInBio />} />
        <Route path="/syarat-ketentuan" element={<Terms />} />
        <Route path="/gratis" element={<LeadMagnet />} />
        <Route path="/terima-kasih" element={<ThankYou />} />
        <Route path="/kontak" element={<Contact />} />
        <Route path="/artikel" element={<ArticlesIndex />} />
        <Route path="/artikel/:slug" element={<ArticleDetail />} />
        <Route path="/login" element={<AdminLogin />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="*" element={<Landing />} />
      </Routes>
      {!isAdminArea && <FloatingContact />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-center" theme="light" />
      </BrowserRouter>
    </div>
  );
}

export default App;
